export const MCP_ENDPOINT = 'mcp-server/http';
export const MCP_DOCS_PAGE_URL = 'https://docs.n8n.io/advanced-ai/mcp/mcp_tools_reference';
export const ELIGIBLE_WORKFLOWS_DOCS_SECTION = 'workflow-eligibility';

export const MCP_SETTINGS_VIEW = 'McpSettings';
export const MCP_STORE = 'mcp';

export const LOADING_INDICATOR_TIMEOUT = 200;
export const MCP_TOOLTIP_DELAY = 100;

export const MCP_CONNECT_POPOVER_WIDTH = 460;

export const MCP_CONNECT_WORKFLOWS_MODAL_KEY = 'mcpConnectWorkflowsModal';
